<template>
  <div class="login">
    <img class="login-logo" src="@/assets/img/login/login-logo.png" alt="" />
    <div class="login-box">
      <div class="login-form">
        <div class="exam-title">人社职业技能认定</div>
        <div class="login-title">后台管理</div>
        <el-form :model="ruleForm" ref="formRef" :rules="rules">
          <el-form-item label="" prop="username">
            <el-input
              v-model.trim="ruleForm.username"
              placeholder="请输入账号"
              size="large"
            >
              <template #prefix>
                <img
                  class="input-icon"
                  src="@/assets/img/login/user.png"
                  alt=""
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              type="password"
              v-model.trim="ruleForm.password"
              placeholder="请输入密码"
              size="large"
              v-on:keyup.enter="submitForm('ruleForm')"
            >
              <template #prefix>
                <img
                  class="input-icon"
                  src="@/assets/img/login/id-card.png"
                  alt=""
                /> </template
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 100%">
            <el-button
              type="primary"
              size="large"
              class="confirm-btn"
              @click="submitForm('formRef')"
              :loading="logining"
              >登 录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// import { login } from '../api/userMG'
import { login } from "../api/login";
// import { baseUrl } from "../utils/util";
import { Login } from "../api/system";

import { setCookie, getCookie, delCookie } from "../utils/util";
// import md5 from 'js-md5'
export default {
  name: "login",
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        code: "",
        randomStr: "",
        codeimg: ""
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.$message({
    //   message: '账号密码不为空',
    //   type: 'success'
    // })
    // 获取图形验证码
    // this.getcode()
    // 获取存在本地的用户名密码
    this.getuserpwd();
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getuserpwd() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.ruleForm.username = getCookie("user");
        this.ruleForm.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;
          let res = Login({
            username: this.ruleForm.username,
            password: this.ruleForm.password
          });
          res
            .then(result => {
              if (result.data.code == 200) {
                if (result.data.data.zh_accesstoken !== "500") {
                  localStorage.setItem("token", result.data.data.access_token);
                  localStorage.setItem(
                    "zh_token",
                    result.data.data.zh_accesstoken
                  );
                  this.logining = false;
                  this.$router.push({ path: "/question/handsOn" });
                } else {
                  this.logining = false;
                  this.$message.error("登录失败");
                }
              } else {
                this.logining = false;
              }
            })
            .catch(e => {
              this.logining = false;
            });
          // this.$https.post(`${baseUrl}/system/auth/login`, {
          //   'username': this.ruleForm.username,
          //   'password': this.ruleForm.password
          // }).then(res => {
          //   console.log(res.data)
          //   if (res.data.code == 200) {
          //     localStorage.setItem('token', res.data.data.access_token)
          //     this.logining = false
          //     this.$router.push({ path: '/academic' })
          //   }else{
          //     this.logining = false
          //     alert(res.data.msg)
          //   }
          // })

          // 注释
          // login(this.ruleForm).then(res => {
          //   if (res.success) {
          //     if (this.rememberpwd) {
          //       //保存帐号到cookie，有效期7天
          //       setCookie('user', this.ruleForm.username, 7)
          //       //保存密码到cookie，有效期7天
          //       setCookie('pwd', this.ruleForm.password, 7)
          //     } else {
          //       delCookie('user')
          //       delCookie('pwd')
          //     }
          //     //如果请求成功就让他2秒跳转路由
          //     setTimeout(() => {
          //       this.logining = false
          //       // 缓存token
          //       localStorage.setItem('logintoken', res.data.token)
          //       // 缓存用户个人信息
          //       localStorage.setItem('userdata', JSON.stringify(res.data))
          //       this.$store.commit('login', 'true')
          //       this.$router.push({ path: '/goods/Goods' })
          //     }, 1000)
          //   } else {
          //     this.$message.error(res.msg)
          //     this.logining = false
          //     return false
          //   }
          // })
        } else {
          // 获取图形验证码
          // this.getcode()
          this.$message.error("请输入用户名密码！");
          this.logining = false;
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.login {
  height: 100%;
  background: #f5f7fa;
  background-image: url("../assets/img/login/login-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .login-logo {
    width: 700px;
    margin-right: 100px;
  }
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .login-form {
    padding: 50px;
    border-radius: 1rem;
    width: 320px;
    background-color: #fff;
    box-shadow: 0 0 20px 2px #bfd2ef66;
  }
  .exam-title {
    text-align: center;
    color: #1c68ff;
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
  }

  .login-title {
    text-align: center;
    margin-bottom: 32px;
    font-size: 28px;
    line-height: 45px;
    font-weight: 600;
    color: #1c68ff;
  }
  /deep/ .el-input {
    width: 100%;
  }
  /deep/ .input-icon {
    width: 28px;
    height: 28px;
    margin-top: 6px;
  }
  /deep/ .el-input__inner {
    background-color: #f7faff !important;
    box-shadow: none;
    padding-left: 36px;
  }
  .confirm-btn {
    width: 100%;
    background-color: #1c68ffff;
    height: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue